import { IconProps } from '@tamagui/helpers-icon';
import { Button, ButtonProps, ButtonRef } from '@unistocks/components/button/button';
import { Row, RowProps } from '@unistocks/components/layout/flex';
import { t } from '@unistocks/shared/localization/index.ts';
import React, { Ref } from 'react';
import { isWeb } from 'tamagui';

export type SubmitButtonsProps = RowProps & {
  cancelButtonRef?: Ref<ButtonRef>;
  cancelButtonText?: string;
  cancelButtonIcon?: React.ComponentType<IconProps>;
  cancelButtonIconAfter?: React.ComponentType<IconProps>;

  submitButtonRef?: Ref<ButtonRef>;
  submitButtonText?: string;
  submitButtonIcon?: React.ComponentType<IconProps>;
  submitButtonIconAfter?: React.ComponentType<IconProps>;
  submitButtonType?: ButtonProps['type'];
  isSubmitting?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
};

export const SubmitButtons: React.FC<SubmitButtonsProps> = ({
  cancelButtonRef,
  cancelButtonText = t('::Back'),
  cancelButtonIcon,
  cancelButtonIconAfter,
  submitButtonRef,
  submitButtonText = t('::Save'),
  submitButtonIcon,
  submitButtonIconAfter,
  submitButtonType = 'submit',
  isSubmitting,
  onCancel,
  onSubmit,
  onPress,
  ...rowProps
}) => (
  <Row $md={{ justifyContent: 'flex-end' }} {...rowProps}>
    <Button
      ref={cancelButtonRef}
      variant={'outlined'}
      size={'$3'}
      $max-sm={{ flex: 1 }}
      Icon={cancelButtonIcon}
      IconAfter={cancelButtonIconAfter}
      disabled={!onCancel}
      onPress={onCancel}
    >
      {cancelButtonText}
    </Button>
    <Button
      /* Changing key to prevent auto submit when type changes to submit */
      key={submitButtonType}
      ref={submitButtonRef}
      type={submitButtonType}
      size={'$3'}
      $max-sm={{ flex: 1 }}
      loading={isSubmitting}
      Icon={submitButtonIcon}
      IconAfter={submitButtonIconAfter}
      onPress={e => {
        // On web a submit-type button already triggers the native form submission,
        // so the press handler must not submit as well (avoids a double submission).
        if (isWeb && submitButtonType === 'submit') {
          return;
        }

        // onSubmit takes precedence over onPress passed from Form trigger
        onSubmit?.();
      }}
    >
      {submitButtonText}
    </Button>
  </Row>
);
